import { IResponse } from "../../model";
import ServiceBase from "../../servicebase";

export type IEmisionGrupalIns = {
  idcliente?: number;
  idcotizador?: number;
  idorigen?: number;
  iddestino?: number;
  fechas?: Date | Date[];
  idproveedor?: number;
  idproducto?: number;
  idmoneda?: number;
  esPrecioNeto?: boolean;
  precio?: number;
  preciousd?: number;
  pasajeros?: number;
  emer_nombre?: string;
  emer_email?: string;
  emer_telefono?: string;
}

export class ActionController extends ServiceBase {
  addEmisionGrupal = (data: IEmisionGrupalIns) : Promise<IResponse<{ code: string }>> => 
    this.PostFetch<IResponse<{ code: string }>>('action/emisiongrupal', data);
}
